(() => {
  const MONEY_PLACEHOLDER = '{{amount}}';

  function formatMoney(cents, moneyFormat) {
    const dollars = cents / 100;
    const map = {
      '{{amount}}': dollars.toFixed(2),
      '{{amount_no_decimals}}': String(Math.round(dollars)),
      '{{amount_with_comma_separator}}': dollars.toFixed(2).replace('.', ','),
      '{{amount_no_decimals_with_comma_separator}}': String(Math.round(dollars)).replace('.', ','),
    };
    let out = moneyFormat || '${{amount}}';
    for (const k in map) out = out.replace(k, map[k]);
    return out;
  }

  const getBars = () => Array.from(document.querySelectorAll('[data-free-shipping-progress]'));

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function cartIsGeneralOnly(cart) {
        if (!cart || !Array.isArray(cart.items)) return false;
        if (cart.items.length === 0) return false;

        // Define your cutoff weight (in grams). Example: 18,000 g = ~40 lb
        const MAX_GENERAL_WEIGHT = 18000;

        // Only consider "general" if *all* items are below the threshold
        return cart.items.every(item => {
            const grams = Number(item.grams) || 0;
            return grams <= MAX_GENERAL_WEIGHT;
        });
    }

  function renderBar(el, cart) {
    if (!cartIsGeneralOnly(cart)) {
        el.style.display = 'none';
        return;
    } else {
        el.style.display = ''; // show again if eligible
    }

    const threshold = Math.round(Number(el.getAttribute('data-threshold') || '0'));
    const safeThreshold = Number.isFinite(threshold) && threshold > 0 ? threshold : 0;

    const moneyFormat = el.getAttribute('data-money-format') || '${{amount}}';
    const msgRemainingTmpl = el.getAttribute('data-msg-remaining') || "You're {{amount}} away from free shipping.";
    const msgUnlocked = el.getAttribute('data-msg-unlocked') || 'You unlocked free shipping!';

    const subtotal = Number.isFinite(cart?.total_price) ? Math.round(cart.total_price) : 0;
    let remaining = Math.max(threshold - subtotal, 0);
    if (remaining <= 1) remaining = 0;

    const qualified = remaining === 0 || safeThreshold === 0;
    const pct = safeThreshold > 0
      ? Math.max(0, Math.min(100, Math.round((subtotal / safeThreshold) * 100)))
      : 100;

    // Un-hide everything just in case the theme hides them
    el.removeAttribute('hidden');
    el.classList.remove('hidden', 'visually-hidden');
    const header = el.querySelector('.free-ship-header');
    const msgEl = el.querySelector('.free-ship-message');
    const bar = el.querySelector('.free-ship-bar');
    const fill = el.querySelector('.free-ship-bar__fill');
    [header, msgEl, bar, fill].forEach(n => {
      if (!n) return;
      n.removeAttribute('hidden');
      n.classList.remove('hidden', 'visually-hidden');
      n.style.display = 'block';
      n.style.visibility = 'visible';
      n.style.opacity = '1';
    });

    if (fill) fill.style.width = pct + '%';

    if (bar) {
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '100');
      bar.setAttribute('aria-valuenow', String(pct));
    }

    if (msgEl) {
      if (qualified) {
        msgEl.textContent = msgUnlocked;
        if (!el.dataset.announced) {
          const live = document.getElementById('cart-live-region-text');
          if (live) live.textContent = msgUnlocked;
          el.dataset.announced = 'true';
        }
      } else {
        el.dataset.announced = '';
        const formatted = formatMoney(remaining, moneyFormat);
        msgEl.textContent = msgRemainingTmpl.replace(MONEY_PLACEHOLDER, formatted);
      }
    }

    el.dataset.qualified = qualified ? 'true' : 'false';
  }

  let updateQueued = false;
  async function updateAll() {
    if (updateQueued) return;
    updateQueued = true;
    try {
      const bars = getBars();
      if (!bars.length) return;
      const cart = await fetchCart();
      bars.forEach(el => renderBar(el, cart));
    } catch (e) {
      console.warn('Free shipping progress update failed', e);
    } finally {
      updateQueued = false;
    }
  }

  /* ---------- Helpers to handle cart notification DOM re-injections ---------- */
  function retryUpdate(times = 6, delay = 150) {
    let i = 0;
    const tick = () => { updateAll(); if (++i < times) setTimeout(tick, delay); };
    tick();
  }

  // Observe Dawn section reloads / popup DOM changes
  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('shopify:section:unload', updateAll);
  document.addEventListener('shopify:section:select', updateAll);
  document.addEventListener('shopify:section:deselect', updateAll);
  // When the cart notification opens, try a short burst of updates.
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('cart-notification');
    if (!container) return;

    const obs = new MutationObserver((muts) => {
      for (const m of muts) {
        if (
          m.type === 'attributes' &&
          m.attributeName === 'open' &&
          container.hasAttribute('open')
        ) {
          // Notification just opened; run a quick retry burst.
          setTimeout(() => {
            // reuse your retry helper
            if (typeof FreeShippingProgress?.update === 'function') {
              FreeShippingProgress.update();
            }
          }, 30);
        }
      }
    });
    obs.observe(container, { attributes: true });
  });

  // Intercept fetches to /cart endpoints
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const req = args[0];
      const url = typeof req === 'string' ? req : (req && req.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        setTimeout(() => retryUpdate(6, 150), 60);
      }
    } catch (_) {}
    return res;
  };

  // Non-AJAX form submissions
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const action = (form.getAttribute('action') || '').replace(location.origin, '');
    if (/^\/cart(\/add)?/.test(action)) setTimeout(() => retryUpdate(6, 150), 120);
  });

  document.addEventListener('DOMContentLoaded', updateAll);
  window.FreeShippingProgress = { update: updateAll };
})();
